// import form from './form';
import accordion from './accordion';
import slideProduct from './slideProduct';
import slideOnayami from './slideOnayami';
import slideAuto from './slideAuto';
import modal from './modal';
import headerScroll from './headerScroll';
import trackHeaderHeight from './trackHeaderHeight';
import imageLoaded from './imageLoaded';
import inview from './inview';
import cssVariable from './cssVariable';
import drawer from './drawer';
import zoomImg from './zoomImg';

document.addEventListener('DOMContentLoaded', () => {
  // form();
  accordion();
  slideProduct();
  slideOnayami();
  slideAuto();
  modal();
  headerScroll();
  trackHeaderHeight();
  imageLoaded();
  cssVariable();
  inview();
  drawer();
  zoomImg();
});
